import React from 'react';
import i18n from '@/modules/i18n';
import Text from '@/components/ui/Text';
import StatusIndicator from '@/components/staffer/Grading/StatusIndicator';
import { formatSyncTimestamp } from '@/components/staffer/AssignmentsBasedGradesTable/LMSSyncStatusToolbar';

interface StatusIndicatorAndTimestampProps {
  turnedInQueryData: { completed_at?: string, created_at: string } | null;
}

const StatusIndicatorAndTimestamp = ({ turnedInQueryData }: StatusIndicatorAndTimestampProps) => {
  if (!turnedInQueryData) return null;

  const status = turnedInQueryData.completed_at ? 'completed' : 'in_progress';
  const isCompleted = status === 'completed';
  const timestamp = isCompleted ? turnedInQueryData.completed_at : turnedInQueryData.created_at;
  const translation = isCompleted ? 'turned_in_on' : 'in_progress_on';
  const turnedInText = i18n.t(translation, { timestamp: formatSyncTimestamp(timestamp) });

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <StatusIndicator status={status} />
      <Text size="sm" xxl={{ size: 'md' }}>
        {turnedInText}
      </Text>
    </div>
  );
};

export default StatusIndicatorAndTimestamp;
